import {
  LucideBell,
  LucideSearch,
  LucideSettings,
  Menu,
  ShoppingCart,
} from 'lucide-react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Input } from '~/components/ui';
import { useTranslate } from '~/hooks/useTranslate';
import type { RootState } from '~/redux/store';

interface TopNavProps {
  onToggleSidebar: () => void;
}

export function TopNav({ onToggleSidebar }: TopNavProps) {
  const navigate = useNavigate();
  const role = useSelector((state: RootState) => state.auth.user?.role);
  const [searchTerm, setSearchTerm] = useState('');
  const { t } = useTranslate();
  return (
    <div className="bg-neut-bg-alt  w-full flex justify-between ">
      <button
        onClick={onToggleSidebar}
        className="p-5 hover:bg-neut-hover rounded-md transition-colors lg:hidden"
        aria-label="Toggle sidebar"
      >
        <Menu data-testid="menu-icon" size={20} color="var(--color-neut-600)" />
      </button>

      <div className="w-full flex justify-between items-center">
        <div className="w-[50%]">
          <Input
            leftIcon={<LucideSearch className="text-neut-sec" />}
            onChange={(_, value) => setSearchTerm(value)}
            placeholder={t('auth.layout.search-placeholder')}
            name={'search'}
            value={searchTerm || ''}
            containerClassName="hidden"
          />
        </div>

        <div
          className={`w-[30%] flex gap-8 justify-end items-center px-8 text-neut-sec p-4 ${role?.toLowerCase() === 'buyer' ? '' : 'hidden'}`}
        >
          <ShoppingCart
            className={`cursor-pointer`}
            onClick={() => navigate('/cart')}
          />
          <LucideBell className="hidden" />
          <LucideSettings className="hidden" />
        </div>
      </div>
    </div>
  );
}
